<div class="suggestions">
    <ai-chat-suggestion
        *ngFor="let suggestion of suggestions"
        [label]="suggestion.text | translate"
        [type]="suggestion.type">
    </ai-chat-suggestion>
</div>
